import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Buefy from 'buefy'

import moment from 'moment'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import VueClipboard from 'vue-clipboard2'
import i18n from '@/language'

import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultContainerElement: '#content'
})

Vue.use(Loading, {
  // props
  color: '#F45735',
  loader: 'dots',
  opacity: 0.95,
  backgroundColor: '#30404D',
  width: 128,
  height: 128
})

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#4A196D',
  cancelButtonColor: '#ff7674'
})

Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.filter('bankAccountFormat', no => {
  if (no) {
    if (no.length == 10) {
      return no.slice(0, 3) + '-' + no.slice(3, 6) + '-' + no.slice(6)
    } else {
      return no
    }
  }

  return no
})

Vue.filter('numberFormat', num => {
  if (typeof num == 'number') {
    return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2 })
  } else {
    return '-'
  }
})

Vue.filter('decimalFormat', num => {
  if (typeof num == 'number') {
    return Number(num).toLocaleString(undefined, { minimumFractionDigits: 0 })
  } else {
    return '-'
  }
})

Vue.filter('datetimeFormat', date => {
  if (date) return moment(date).format('DD/MM/YYYY HH:mm:ss')
  else return '-'
})

Vue.filter('timeChatFormat', date => {
  if (date) return moment(date).format('HH:mm:ss')
  else return '-'
})

Vue.filter('dateChatFormat', date => {
  if (date) return moment(date).format('ddd, DD MMM YYYY')
  else return ''
})

Vue.filter('timeagoFormat', datetimeString => {
  const date = new Date(datetimeString)

  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 0 }
  ]

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  const interval = intervals.find(i => i.seconds < seconds)
  const count =
    interval.seconds > 0 ? Math.floor(seconds / interval.seconds) : seconds

  return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`
})

Vue.directive('uppercase', {
  update: function(el) {
    el.value = el.value.toUpperCase()
  }
})

if (process.env.VUE_APP_BASE_CHATBACKEND) {
  Vue.use(
    new VueSocketIO({
      debug: false,
      connection: SocketIO(
        process.env.VUE_APP_BASE_CHATBACKEND.replace('/api', ''),
        {
          transports: ['websocket']
        }
      ),
      options: {
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 500,
        maxReconnectionAttempts: Infinity
      }
    })
  )
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
